import { type ReactNode } from 'react'

interface ErrorBoundaryInfoProps {
  debugInfo?: Record<string, string>;
  heading: ReactNode;
  message: ReactNode;
  status?: ReactNode;
}

/**
 * A reusable component for displaying information about errors caught by an
 * error boundary.
 */
export function ErrorBoundaryInfo ({ debugInfo, heading, message, status }: ErrorBoundaryInfoProps) {
  function renderDebugInfo () {
    if (!debugInfo) return null

    return (
      <dl>
        {Object.entries(debugInfo).map(([label, value], index) => (
          <div className='text-gray-500 body-sm flex items-start gap-1' key={index}>
            <dt>{label}:</dt>
            <dd><code>{value}</code></dd>
          </div>
        ))}
      </dl>
    )
  }

  return (
    <div className='p-4 max-w-md'>
      {status && (
        <div className='body text-thatch-500 mb-1'>
          {status}
        </div>
      )}
      <h1 className='heading-lg mb-6'>
        {heading}
      </h1>
      <div className='space-y-2'>
        <p className='body'>{message}</p>
        {renderDebugInfo()}
      </div>
    </div>
  )
}
